import React from 'react';
import { Layout, DeveloperApi } from '../components';

const Api = () => {
  return (
    <Layout page="api">
      <DeveloperApi />
    </Layout>
  );
};

export default Api;
